/**
 * AI Marketplace — Color tokens
 * Use these constants in MUI `sx` props and `styled()` components
 * instead of hardcoded hex strings. Mirrors variables.css.
 */

export const Colors = {
  /* Brand */
  navy:          '#001C53',
  dark:          '#221D43',
  white:         '#FFFFFF',

  /* Hero accents */
  cyan:          '#6CD0FF',
  cyanLight:     '#90D5FF',
  purpleAccent:  '#5130ED',
  deepNavy:      '#092151',

  /* Essential-app card blues */
  blueMedium:    '#1668C0',
  blueDark:      '#0D3F86',
  blueLight:     '#EEF4FF',
  bluePale:      '#CDDDF3',
  blueSky:       '#CFE3FF',
  blueMuted:     '#9FB6D6',

  /* UI surface */
  divider:       '#C7D2E8',
} as const;
